module.exports = {
  siteTitle: 'Sanjiv Kawa',
  siteDescription:
    'I am a creative, dedicated, goal-oriented individual with over 10 years of experience as a cyber security consultant.',
  siteKeywords:
    'Sanjiv Kawa, Sanjiv, Kawa, sanjivkawa, skahwah, information security, security, infosec, cyber security, cyber, red team, adversarial simulation, penetration test, hack, hacker, hacking',
  siteUrl: 'https://popped.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'G-7HE3QVEYCY',
  name: 'Sanjiv Kawa',
  email: 'sanjiv@popped.io',
  github: 'https://github.com/skahwah',
  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/sanjivkawa',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/skahwah',
    },
    {
      name: 'TwitterX',
      url: 'https://twitter.com/sanjivkawa',
    },
    {
      name: 'Mastodon',
      url: 'https://mastodon.social/@sanjivkawa@infosec.exchange',
    },
    {
      name: 'Document',
      url: 'https://popped.io/resume.pdf',
    }
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
